export const GET_ORGANIZATIONS = '@uhc/utility/GET_ORGANIZATIONS';
export const GET_TAX_ID_NUMBERS = '@uhc/utility/GET_TAX_ID_NUMBERS';
export const GET_PROVIDERS = '@uhc/utility/providers/GET_PROVIDERS';
export const GET_SAVED_PROVIDER = '@uhc/utility/GET_SAVED_PROVIDER';
export const POST_SAVED_PROVIDER = '@uhc/utility/POST_SAVED_PROVIDER';
